"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ironStorageConfig = void 0;
exports.ironStorageConfig = {
    name: 'storage-iron',
    fullname: 'Iron Storage',
    description: 'Storage for iron ingots and iron ore.',
    type: 'storage',
    width: 1,
    height: 1,
    levelMax: 9,
    canBeDisabled: false,
    requiredTechnology: 'iron',
    levels: [
        { level: 0, constructionCosts: {}, time: 1, provides: {}, costs: {}, stores: { iron: 10 } },
        { level: 1, constructionCosts: { iron: 5 }, time: 1, provides: {}, costs: {}, stores: { iron: 20 } },
        { level: 2, constructionCosts: { iron: 10 }, time: 1, provides: {}, costs: {}, stores: { iron: 40 } },
        { level: 3, constructionCosts: { iron: 30 }, time: 1, provides: {}, costs: {}, stores: { iron: 100 } },
        { level: 4, constructionCosts: { iron: 70 }, time: 1, provides: {}, costs: {}, stores: { iron: 200 } },
        { level: 5, constructionCosts: { iron: 150 }, time: 1, provides: {}, costs: {}, stores: { iron: 400 } },
        { level: 6, constructionCosts: { iron: 300 }, time: 1, provides: {}, costs: {}, stores: { iron: 1000 } },
        { level: 7, constructionCosts: { iron: 500 }, time: 1, provides: {}, costs: {}, stores: { iron: 2000 } },
        { level: 8, constructionCosts: { iron: 1000 }, time: 1, provides: {}, costs: {}, stores: { iron: 3000 } },
        { level: 9, constructionCosts: { iron: 2000 }, time: 1, provides: {}, costs: {}, stores: { iron: 5000 } },
    ],
};



//////////////////
// WEBPACK FOOTER
// ../engine/dist/config/buildings/ironstorage.js
// module id = cCz4
// module chunks = 0